import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { publicFetch } from "../../utils/fetch";
import { setSnackbar } from "./snackbar.slice";

export const getAboutContent = createAsyncThunk(
  "about/getAbout",
  async (_, { dispatch, rejectWithValue, getState }) => {
    try {
      // const privateFetch = publicFetch(getState().user.token);
      const response = await publicFetch.get(
        // `/api/v1/categories?page=1&limit=10`
        `/api/v1/about`
      );
      return response.data;
    } catch (error) {
      const responseMessage = error.response.data.message;
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarType: "error",
          snackbarMessage: responseMessage,
        })
      );
      return rejectWithValue(responseMessage);
    }
  }
);

const aboutSlice = createSlice({
  name: "about",
  initialState: {
    data: [],
    totalCount: 0,
    page: 0,
    status: "",
    message: "",
  },
  extraReducers: {
    [getAboutContent.pending]: (state, action) => {
      state.status = "LOADING";
    },
    [getAboutContent.fulfilled]: (state, { payload }) => {
      state.data = payload.result;
      state.status = "SUCCESS";
    },
    [getAboutContent.rejected]: (state, action) => {
      state.status = "FAILED";
    },
  },
});
export default aboutSlice.reducer;
